import * as _ from "lodash";
import { LIB_PREFIX, IManifest, ContentTypes }
    from "../../TypesAndIdentifiers";
export default class BaseConfig {
    private DEFAULT_MANIFEST: IManifest = {
        modules: [
            "pls-ucsd"
        ]
    };

    public readonly libPrefix = LIB_PREFIX;
    public manifest: IManifest = this.DEFAULT_MANIFEST;
    public appConfig: any;
    public contentType: ContentTypes;
    public attributes: any;
    public state: any;
    /**
     * Ex: com.playpower.questionTypes.bubblePop.click
     */
    public contentTypeID: string;

    /**
     * To mutate any of the config value
     * @example set({ frameRate: 20, { canvasConfig: { isResp: false }} })
     * @memberof QuestionConfig
     */
    public set(obj): void {
        _.merge(this, obj);
    }

    public setAttributesAndStates(attributes: any, state: any): void {
        this.attributes = attributes;
        this.state = state;
    }
    public getProperty(key: string): any {
        if (this.attributes && this.attributes[key] !== undefined) {
            return this.attributes[key];
        }
        if (this.state && this.state[key] !== undefined) {
            return this.state[key];
        }
    }
}
